import { Injectable } from '@angular/core';
import type { DateRange } from 'moment-range';

import { ChartShowModes, Form } from '@site-mate/dashpivot-shared-library';

import { AnalyticsService } from 'app/analytics/analytics.service';
import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';
import { ChartUtilsService } from 'app/shared/service/chart-utils.service';

import { FrequencyBarChartDataParser } from './frequency-bar-chart-data-parser';
import { FrequencyCumulativeBarChartDataParser } from './frequency-cumulative-bar-chart-data-parser';

@Injectable()
export class FrequencyChartDataService {
  constructor(
    private readonly barChartDataParser: FrequencyBarChartDataParser,
    private readonly cumulativeBarChartDataParser: FrequencyCumulativeBarChartDataParser,
    private readonly analyticsService: AnalyticsService,
    private readonly chartUtilsService: ChartUtilsService,
  ) {}

  async loadChartData(chart: ChartSettings, dateRange) {
    const forms = await this.analyticsService
      .listTemplateForms(chart.templateId, this.chartUtilsService.getURLParams(chart))
      .toPromise();

    return this.parseForms(chart, forms, dateRange);
  }

  parseForms(chart: ChartSettings, forms: Form[] = [], dateRange: DateRange) {
    const result = {} as any;

    if (!forms.length) {
      return result;
    }

    switch (chart.showAs) {
      case ChartShowModes.Bar:
        result.barChartData = this.barChartDataParser.parseForms(forms, chart, dateRange);
        break;
      case ChartShowModes.Cumulative:
        result.cumulativeBarChartData = this.cumulativeBarChartDataParser.parseForms(forms, chart, dateRange);
        break;
      default:
        result.barChartData = this.barChartDataParser.parseForms(forms, chart, dateRange);
    }

    return result;
  }
}
